import Alpine from "alpinejs";

/* 1st party components */
import { app } from "./app.js";
import { cookieConsent } from "./cookieConsent.js";
import { founding } from "./founding.js";
import { newsletter } from "./newsletter.js";
import { slideshow } from "./slideshow.js";
import { support } from "./support.js";
import { unsubscribe } from "./unsubscribe.js";

/* plugins */

/* data components */
Alpine.data("app", app);
Alpine.data("cookieConsent", cookieConsent);
Alpine.data("founding", founding);
Alpine.data("newsletter", newsletter);
Alpine.data("slideshow", slideshow);
Alpine.data("support", support);
Alpine.data("unsubscribe", unsubscribe);

/* start your engines */
window.Alpine = Alpine;
Alpine.start();
